import { render, staticRenderFns } from "./TypeCourseList.vue?vue&type=template&id=622d78c9&scoped=true&"
import script from "./TypeCourseList.vue?vue&type=script&lang=js&"
export * from "./TypeCourseList.vue?vue&type=script&lang=js&"
import style0 from "./TypeCourseList.vue?vue&type=style&index=0&id=622d78c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622d78c9",
  null
  
)

export default component.exports